import { useSelector } from 'react-redux'
import { Concept, ConceptValues } from '../../../../../../../../types/Survey/Analysis/Concept'
import props from '../../../../../../../../redux/props'
import Button from '../../../../../../../UI/Button/Button'
import { useState } from 'react'
import Modal from '../../../../../../../UI/Modal/Modal'
import useConceptConfiguration from '../../../useConceptConfiguration'
import Dropdown from '../../../../../../../UI/Dropdown/Dropdown'

type Props = {
  values: ConceptValues
  concept: Concept
}

const Remove: React.FC<Props> = ({ values, concept }) => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const [open, setOpen] = useState(false)
  const { removeUnitValues } = useConceptConfiguration()
  const [maReceiverUnitUUID, setMaReceiverUnitUUID] = useState('')
  const toggle = () => setOpen(!open)

  const triggerRemove = () => {
    removeUnitValues(values.unitUUID, maReceiverUnitUUID)
    toggle()
  }

  const unitItems = () => {
    return Object.keys(concept.units)
      .filter((key) => key !== values.unitUUID && key !== 'sum')
      .map((key) => ({ label: concept.units[key].name, value: concept.units[key].unitUUID }))
  }

  return (
    <div className="flex justify-end">
      <Button text={t.survey.analysis.calculation.values.splitting.remove} onClick={toggle} />
      <Modal onConfirm={triggerRemove} show={open} onClose={toggle} title={`${values.name}${t.survey.analysis.concept.unitRemove.titleSuffix}`}>
        <div className="text-sm text-gray-500">{t.survey.analysis.concept.unitRemove.hint}</div>
        <div className="flex flex-col gap-3 mt-3">
          <Dropdown
            label={t.survey.analysis.concept.unitRemove.maReceiverUnit}
            value={maReceiverUnitUUID}
            onChange={setMaReceiverUnitUUID}
            items={unitItems()}
          />
        </div>
      </Modal>
    </div>
  )
}

export default Remove
